import { Star } from 'lucide-react';

interface StarRatingProps {
  rating: number | null | undefined;
  maxRating?: number;
  size?: 'sm' | 'md' | 'lg';
  interactive?: boolean;
  onRatingChange?: (rating: number) => void;
  label?: string;
}

const STAR_LABELS: Record<number, string> = {
  1: 'Premier brouillon',
  2: 'Commencé mais pas prêt pour la prod',
  3: 'On peut le mettre en production',
  4: 'Satisfait mais manque un petit quelque chose',
  5: 'Tout est sur la coche',
};

export function StarRating({
  rating,
  maxRating = 5,
  size = 'md',
  interactive = false,
  onRatingChange,
  label,
}: StarRatingProps) {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const handleClick = (newRating: number) => {
    if (interactive && onRatingChange) {
      onRatingChange(newRating);
    }
  };


  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        {Array.from({ length: maxRating }, (_, i) => i + 1).map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => handleClick(star)}
            disabled={!interactive}
            className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform`}
          >
            <Star
              className={sizeClasses[size]}
              fill={rating && star <= rating ? '#F59E0B' : 'none'}
              stroke={rating && star <= rating ? '#F59E0B' : '#D1D5DB'}
              strokeWidth={rating && star <= rating ? 0 : 1.5}
            />
          </button>
        ))}
      </div>
      {label && (
        <span className="text-[10px] text-gray-500">{label}</span>
      )}
      {rating && STAR_LABELS[rating] && (
        <span className="text-[10px] text-gray-600 font-medium">{STAR_LABELS[rating]}</span>
      )}
    </div>
  );
}

